
import { HIVOLUME_TINS_API_URL } from '@src/middleware/services/hiVolumeTins/apiUrlConstants';
interface TinObject {
  Tin: string;
  tinName: string;
  taxIdType: string;
  regionName: string;
  majorMarketName: string;
  marketNumber: string;
  invalid?: boolean;
}

export const getCommaSeperatedTins = (tins: TinObject[]): string => {
  if (!tins || tins.length === 0) {
    return '';
  }
  return tins
    .map((tinObj) => tinObj.Tin.trim())
    .filter((Tin) => Tin)
    .join(', ');
};

export const getCommaSeperatedValidTins = (tins: TinObject[]): string => {
  if (!tins || tins.length === 0) {
    return '';
  }
  return tins
    .filter((tinObj) => !tinObj.invalid)
    .map((tinObj) => tinObj.Tin.trim())
    .filter((Tin) => Tin)
    .join(',');
};

export const checkIfCustomListMaxReached = (): boolean => {
  const customListCount = sessionStorage.getItem('customListCount');
  if (customListCount) {
    const count = parseInt(customListCount, 10);
    return count >= 5; // Assuming the maximum is 10
  }
  return false; // Default return value if customListCount is null or undefined
};

export const getFilteredTins = (Tins, key) => {
  if (!Tins && !Tins || Tins.length === 0) {
    return [];
  }
  return Tins.filter(
    (tin) =>
      tin.Tin.toLowerCase().includes(key.toLowerCase()) ||
      tin.TinName.toLowerCase().includes(key.toLowerCase())
  );
};

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getAddMoreTinURL = (payload: any): string => {
  const isNumeric = /^[0-9]+$/.test(payload.SearchValue);
  const searchType = isNumeric ? 'tin' : 'tinname';
  return `${HIVOLUME_TINS_API_URL}${searchType}`;
};

export const checkIfTinsAlreadyAdded = (tinsDetails: TinObject[], selectedTin: TinObject): boolean => {
  return Array.isArray(tinsDetails) && tinsDetails.some(
    (tin) => tin.Tin === selectedTin.Tin
  );
};
